import { render } from "./BrandFilter.vue?vue&type=template&id=3197ec8d"
import script from "./BrandFilter.vue?vue&type=script&lang=js"
export * from "./BrandFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__